module.exports = __webpack_public_path__ + "static/media/clyekim47.612d6251.png";